import { Box, Text, InfoIcon, Thumbnail } from '@wix/design-system';
import React__default, { useContext } from 'react';
import { ZIndexContext } from 'ricos-context';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';

var css_248z = "[dir] .yUEuk{margin-top:var(--ricos-thumbnail-picker-margin-top,0)}.h2ExU{display:grid;grid-template-columns:repeat(4,60px);justify-content:space-between;row-gap:12px}";
var classes = {"root":"yUEuk","container":"h2ExU"};
styleInject(css_248z);

const ThumbnailPicker = ({
  title,
  titleInfoContent,
  selectedValue,
  onChange,
  dataSource
}) => {
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ React__default.createElement(Box, { direction: "vertical", gap: "SP3", className: classes.root }, titleInfoContent ? /* @__PURE__ */ React__default.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, title), /* @__PURE__ */ React__default.createElement(
    InfoIcon,
    {
      size: "small",
      content: titleInfoContent,
      tooltipProps: {
        appendTo: (el) => {
          var _a;
          return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
        },
        zIndex: zIndexService.getZIndex("TOOLTIP")
      }
    }
  )) : /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, title), /* @__PURE__ */ React__default.createElement("div", { className: classes.container }, dataSource.map(({ value, dataHook, renderBackgroundImage, label }) => /* @__PURE__ */ React__default.createElement(
    Thumbnail,
    {
      key: value,
      size: "small",
      selected: value === selectedValue,
      title: label ? /* @__PURE__ */ React__default.createElement(Text, { size: "tiny" }, label) : void 0,
      onClick: () => onChange(value),
      height: "60px",
      backgroundImage: renderBackgroundImage({
        height: "40px",
        width: "40px",
        margin: "5px"
      }),
      dataHook
    }
  ))));
};

export { ThumbnailPicker };
//# sourceMappingURL=thumbnail-picker.js.map
